// extracted by mini-css-extract-plugin
export default {"dragPreview":"QualityProfileItemDragPreview-dragPreview-NbgaE"};